import { HoverHintWrapper } from '@domain-group/suit-theme'

import ColouredCircle from '@components/ColouredCircle'

import type { PublicationBookingModel, StatusModel } from '@models/types'

interface RenderStatusCheckboxProps {
  dates: PublicationBookingModel['dates'],
  status: StatusModel,
}

const StatusCheckbox = (props: RenderStatusCheckboxProps) => {
  const { dates, status } = props
  const { key } = status || {}

  // Approved - dates.approval.date_time
  if (key === 'approved'){
    return (
      <HoverHintWrapper
        height={16}
        hintComponent={<HoverHintWrapper.Hint>{`Approved ${dates?.approval.date_time}`}</HoverHintWrapper.Hint>}
        width={16}
      >
        <ColouredCircle backgroundColor="green" />
      </HoverHintWrapper>
    )
  }

  // Booked - dates.booking.date_time
  if (key === 'booked'){
    return (
      <HoverHintWrapper
        height={16}
        hintComponent={<HoverHintWrapper.Hint>{`Booked ${dates?.booking.date_time}`}</HoverHintWrapper.Hint>}
        width={16}
      >
        <ColouredCircle backgroundColor="blue" />
      </HoverHintWrapper>
    )
  }

  // Pending - dates.created.date_time
  return (
    <HoverHintWrapper
      height={16}
      hintComponent={<HoverHintWrapper.Hint>{`Created ${dates?.created.date_time}`}</HoverHintWrapper.Hint>}
      width={16}
    >
      <ColouredCircle />
    </HoverHintWrapper>
  )
}

export default StatusCheckbox
